import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { accountShape } from '@adsk/bim360-matrix-react-helpers/es/propTypes';
import {
  getOrCreateGlobalContext,
  CONTEXT_NAMES
} from '@adsk/bim360-matrix-react-helpers/es/globalContexts';

const AccountContext = getOrCreateGlobalContext(CONTEXT_NAMES.AccountContext);

export const AccountProvider = ({ account, children }) => (
  <AccountContext.Provider value={account}>{children}</AccountContext.Provider>
);

AccountProvider.propTypes = {
  account: accountShape,
  children: PropTypes.node.isRequired
};

export const useAccount = () => useContext(AccountContext);

export default AccountContext;
